module.exports = __webpack_public_path__ + "static/media/CoinIcon.82f60172.png";